import { useSyncExternalStore } from "react";
import { store } from "../../redux/store";
import {
  installMethod,
  isIos,
  isStandalone,
} from "../../utils/install-platform";

const HINT_SHOWN_KEY = "split-it:install-hint-shown";

let state = {
  promptEvent: null,
  sheetOpened: false,
  installed: false,
};
const listeners = new Set();

const setState = (change) => {
  state = { ...state, ...change };
  listeners.forEach((listener) => listener());
};

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// Chromium fires beforeinstallprompt early, possibly before React mounts.
window.addEventListener("beforeinstallprompt", (event) => {
  event.preventDefault();
  setState({ promptEvent: event });
});
window.addEventListener("appinstalled", () =>
  setState({ promptEvent: null, sheetOpened: false, installed: true }),
);

let startedWithoutGroups = false;
const captureStart = () => {
  const current = store.getState();
  if (!current._persist?.rehydrated) return false;
  startedWithoutGroups =
    current.groups.length === 0 && !current.session.selectedGroup;
  return true;
};
const unsubscribeStart = store.subscribe(() => {
  if (captureStart()) unsubscribeStart();
});
if (captureStart()) unsubscribeStart();

export const wasStartedWithoutGroups = () => startedWithoutGroups;

export const isInstallHintShown = () => {
  try {
    return window.localStorage.getItem(HINT_SHOWN_KEY) !== null;
  } catch (error) {
    return true;
  }
};

export const markInstallHintShown = () => {
  try {
    window.localStorage.setItem(HINT_SHOWN_KEY, new Date().toISOString());
  } catch (error) {}
};

export const openInstallSheet = () => setState({ sheetOpened: true });
export const closeInstallSheet = () => setState({ sheetOpened: false });

export const promptInstall = async () => {
  const { promptEvent } = state;
  if (!promptEvent) return;
  setState({ promptEvent: null, sheetOpened: false });
  promptEvent.prompt();
  const choice = await promptEvent.userChoice;
  if (choice?.outcome === "accepted") setState({ installed: true });
};

const getSnapshot = () => state;

export const useInstall = () => {
  const current = useSyncExternalStore(subscribe, getSnapshot);
  const method = current.installed
    ? null
    : installMethod({
        standalone: isStandalone(),
        ios: isIos(),
        canPrompt: Boolean(current.promptEvent),
      });
  return { method, sheetOpened: current.sheetOpened };
};
